module.exports = __webpack_public_path__ + "img/businesslicense.de13ea3e.png";